import { apiFetchMutiCouponList } from '@/api/imee'

const OriginPayList = ['Apple Pay', 'Google Pay']

export const mixin = {
  data() {
    return {
      scene: this.$route.query.scene || null,

      // 优惠券
      maxCoupon: null,
      showCoupons: false,
      selectedCoupon: null,
      validCouponList: [],

      // 默认支付方式-接口返回
      defaultChannel: '',
      originPayInfoReady: false,
      thirdPayListReady: false,

      // 支付结果
      showResultDia: false,
      payResultText: '',
    }
  },
  computed: {
    defaultPaySelectionReady() {
      return this.originPayInfoReady && this.thirdPayListReady
    },
  },
  watch: {
    // 原生支付信息、三方支付列表均就绪后，执行默认选中
    defaultPaySelectionReady(val) {
      if (val) {
        this.selectDefaultPayType()
      }
    },
  },
  methods: {
    // 跳转客服页面
    goCustomer() {
      this.appAction('open_customer_service_page', '')
    },

    // 获取shopType
    // prettier-ignore
    getShopType () {
      if (this.$route.query.shopType) {
        return this.$route.query.shopType
      }
      else {
        return this.scene == 'activity' ? 7 : null
      }
    },

    // 三方支付支付跳转外部页面-支付结果-客户端回调
    onNewIntent(url) {
      if (url) {
        const data = JSON.parse(url)
        if (data.status == 'PENDING') {
          this.payResultText = this.$t('lang.BaseCommon.k090')
          this.showResultDia = true
        }
        if (data.status == 'FAILED') {
          this.payResultText = this.$t('lang.BaseCommon.k089')
          this.showResultDia = true
        }
        if (data.status == 'CLOSED') {
          this.payResultText = 'Closed'
          this.showResultDia = true
        }
      }

      // 刷新页面
      this.init()
    },

    // 支付结果-关闭弹窗
    cancelAgain() {
      this.showResultDia = false
    },

    // 优惠券-初始化
    initCoupon() {
      this.resetCoupon()
      if (this.scene != 'activity') {
        const coinAmount = this.myPlus(this.amount, this.presentAmount)
        apiFetchMutiCouponList({ coinAmount }).then((resData) => {
          if (resData) {
            // 有效的
            this.validCouponList = resData.validCouponRecords || []
            this.findMaxCoupon(this.validCouponList, true)
          }
        })
      }
    },

    // 优惠券-重置
    resetCoupon() {
      this.maxCoupon = null
      this.showCoupons = false
      this.selectedCoupon = null
      this.validCouponList = []
    },

    // 优惠券-找最优
    findMaxCoupon(couponList, useMax) {
      try {
        if (couponList && couponList.length) {
          const tempCoupon = couponList[0]
          if (tempCoupon.canUse === true) {
            this.maxCoupon = tempCoupon
            if (useMax) {
              this.selectedCoupon = tempCoupon
            }
          }
          //
          else {
            this.maxCoupon = null
            if (useMax) {
              this.selectedCoupon = null
            }
          }
        }
      } catch (err) {
        console.log('try catch err', err)
      }
    },

    // 优惠券-打开列表
    handleClickCouponEnter() {
      if (this.showCoupons) {
        this.showCoupons = false
        return
      }

      const hasCoupon = this.validCouponList && this.validCouponList.length
      if (hasCoupon) {
        const nowTime = Date.now()
        this.validCouponList.forEach((item) => {
          if (nowTime > item.expiredTime) {
            item.canUse = false
          }
        })

        this.validCouponList = this.validCouponList.filter((item) => item.canUse)

        if (this.selectedCoupon) {
          if (!this.validCouponList.some((couponItem) => couponItem.couponRecordId === this.selectedCoupon.couponRecordId)) {
            this.selectedCoupon = null
          }
        }
      }

      this.showCoupons = this.validCouponList && this.validCouponList.length
    },

    // 优惠券-选择
    handleSelectCoupon(item) {
      if (item && item.canUse === true) {
        this.selectedCoupon = item
        this.showCoupons = false
      }
    },

    // 处理最优 和 上次使用显示
    resolveBestAndLastUsed() {
      if (this.payList.length) {
        const lastUsedChannelIndex = this.payList.findIndex((item) => item.name === this.lastUsedChannel)
        let lastUsedObj = null
        if (lastUsedChannelIndex > -1) {
          lastUsedObj = this.payList[lastUsedChannelIndex]
          lastUsedObj['lastUsed'] = true
        }

        const bestIndex = this.payList.findIndex((item) => item.ifBestPrice)
        let bestObj = null
        if (bestIndex > -1) {
          bestObj = this.payList[bestIndex]
          bestObj['best'] = true
        }
      }
    },

    // 支付方式-默认
    // prettier-ignore
    selectDefaultPayType() {
      try {
        // 原生支付(有原生支付&默认支付也是原生支付)
        if (OriginPayList.includes(this.defaultChannel) && this.googlePrice) {
          this.selectOriginPay()
          return
        }

        // 三方支付
        // 匹配defaultChannel同名方式-选中
        const tempIndex = this.payList.findIndex((item) => item.name === this.defaultChannel)
        if (tempIndex > -1) {
          this.selectThirdPay(this.payList[tempIndex], tempIndex)
        }
        // 无defaultChannel同名方式-选中第一个
        else {
          this.payList.length && this.selectThirdPay(this.payList[0], 0)
        }
      }
      catch (err) {
        console.log('try catch err', 'selectDefaultPayType')
      }
    },
  },
  mounted() {
    window.onNewIntent = this.onNewIntent
  },
}
